var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('file-pond',{ref:"pond",attrs:{"name":"test","label-idle":_vm.displayName ||
    'Drop files here or <span class=\'filepond--label-action\'>Browse</span>',"allow-multiple":_vm.allowMultiple,"server":{ process: _vm.process },"accepted-file-types":_vm.acceptedFileTypes,"allow-file-type-validation":_vm.onlyPdf}})}
var staticRenderFns = []

export { render, staticRenderFns }